define(
    'viewmodels/secured/explorer/details/tabs/actions/actionsUploadAsVersion/actionsUploadAsVersion',[
        "viewmodels/secured/explorer/context",
        "viewmodels/ViewModelNotification",        
        "services/config",
        "providers/dataprovider",
        "i19n!i19n/strings",
        "plugins/router",
        "dropzone",
        "viewmodels/controller"
    ],
    function (ctx, ViewModelNotification, config, dataProvider, i19n, router, Dropzone, shell) {
        var myDropzone = null;

        var vm = new ViewModelNotification(
        {
            i19n: i19n,
            headings: ko.observable(''),
            subheading: ko.observable(''),            
            isVisible: ko.observable(false),
            isUploadDocument: ko.observable(false),
            document: null
        });        
       
        vm.activate = function () {
            if (!(window.File && window.FileReader && window.FileList && window.Blob)) {
                alert("The file APIs not fully supported in this browser");

                vm.isVisible(false);

                if (sessionStorage.__url) {
                    window.location.href = sessionStorage.__url;
                } else {
                    if (sessionStorage.__url) {
                        window.location.href = sessionStorage.__url;
                    } else {
                        router.navigate("explorer");
                    }
                    //router.navigate("explorer");
                }
                //router.navigate("explorer");

                return false;
            }
            if (!ctx.current.document) {
                vm.isVisible(false);

                router.navigate("explorer");

                return false;
            }

            vm.notifications([]);
            vm.isVisible(true);
            vm.isUploadDocument(false);

            vm.document = ctx.current.document;

            var data = {
                filedIn: !vm.document.filedIn ? "" : vm.document.filedIn,
                documentId: !vm.document.documentId ? "" : vm.document.documentId,
                title: !vm.document.title ? "" : vm.document.title
            };
                        
            if (data.filedIn) {
                vm.headings(data.filedIn);
                vm.subheading(String.format(i19n.to.theuploadedfilewillbesavedasthenextversionof_, data.title));
            } else {
                dataProvider
                .documents
                .getDocumentDetails(vm.document.documentId, vm.document.libraryId)
                .done(function (result) {
                    vm.headings(result.details.filedIn);
                    vm.subheading(String.format(i19n.to.theuploadedfilewillbesavedasthenextversionof_, !result.details.title ? data.title : result.details.title.value));
                });
            }
        };
        vm.attached = function () {
            var options = {
                url: "#",
                paramName: "file",
                maxFilesize: config.maxFilesizeUpload,
                accept: function (file, done) {
                    done();
                },
                uploadMultiple: false,
                autoProcessQueue: true,

                method: "PUT",

                init: function () {
                    this.on("processing", function (file, done) {
                        dataProvider.signurl
                        .uploadFileAsVersion({
                            action: "actionstart",
                            documentId: vm.document.documentId,
                            //folderId: ctx.current.folder.folderId,
                            title: file.filename,
                            extension: file.fileext,
                        })
                        .done(function (data) {
                            file.fileurl = data.repositoryPutUrl;
                            file.revision = data.revision;
                            file.documentId = data.documentId;

                            done(file);
                        })
                        .fail(function (e) {
                            console.error(e);

                            done(file);
                            myDropzone.cancelUpload(file);
                        });
                    });
                    this.on("addedfile", function (file) {
                        try {
                            var rx = /(?:\.([^.]+))?$/;

                            file.filename = file.name;
                            file.fileext = rx.exec(file.name)[1];

                            if (file.filename !== file.fileext) {
                                file.filename = file.filename.substring(0, file.filename.length - file.fileext.length - 1);
                            }

                        } catch (ex) { }

                        file.fileretry = 0;

                        vm.isUploadDocument(myDropzone.files.length > 0);

                        vm.eventBroker.trigger(vm, vm.config.events.header.show, { isShow: false });
                    });
                    this.on("removedfile", function (file) {
                        vm.isUploadDocument(myDropzone.files.length > 0);
                    });
                    this.on("sending", function (file, xhr, formData) {
                        xhr.setRequestHeader('content-type', ' ');
                    });
                    this.on("complete", function (file) {
                        vm.eventBroker.trigger(vm, vm.config.events.header.show, { isShow: true });
                    });
                    this.on("error", function (file, response) {
                        if (file.accepted) {
                            file.fileretry++;
                            if (file.fileretry < 4) {
                                setTimeout(function () {
                                    myDropzone.processFile(file);
                                }, 10000 * file.fileretry);
                            }
                        }

                        console.error(response);
                    });
                    this.on("maxfilesexceeded", function () {
                        vm.notify('error', i19n.to.maxfileexceeded);
                    });
                    this.on("success", function (file, documentId) {
                        dataProvider.signurl
                        .uploadFileAsVersion({
                            action: "actioncomplete",
                            documentId: file.documentId,
                        })
                        .done(function (data) {
                            myDropzone.removeFile(file);

                            if (myDropzone.files.length == 0) {
                                //window.location.reload();

                                vm.eventBroker.trigger(vm, vm.config.events.header.show, { isShow: true });

                                vm.isVisible(false);

                                if (sessionStorage.__url) {
                                    window.location.href = sessionStorage.__url;
                                } else {
                                    router.navigate("explorer");
                                }
                                //router.navigate("explorer");

                                //ctx.onReloadFolders({ documentId: vm.document.documentId });                              
                                ctx.onReloadFolders({ documentId: !documentId ? file.documentId : documentId, _updateNode: { docCount: ctx.current.folder.docCount + 1, text: ctx.current.folder.name() }, isLoadResults: true });
                            }                            
                        })
                        .fail(function (e) {
                            console.error(e);

                            myDropzone.cancelUpload(file);

                            vm.eventBroker.trigger(vm, vm.config.events.header.show, { isShow: true });
                        });
                    });
                    this.on("totaluploadprogress", function (uploadProgress, totalBytes, totalBytesSent) {
                        //console.warn(totalBytesSent + " of " + totalBytes + " (" + uploadProgress + " %)");
                    });
                },
                addRemoveLinks: true,
                dictDefaultMessage: '<span class="bigger-150 bolder">Drop a file</span> to upload \
            	                         <span class="smaller-80 grey">(or click)</span> <br /> \
            	                         <i class="fa fa-cloud-upload blue fa-3x"></i> <br /> \
                                         <span class="smaller-60 grey">Maximum size per file is ' + config.maxFilesizeUpload + 'MB</span>',
                dictResponseError: 'Error while uploading file!',                
                previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-details\">\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n    <div class=\"dz-size\" data-dz-size></div>\n    <img data-dz-thumbnail />\n  </div>\n  <div class=\"progress progress-small progress-striped active\"><div class=\"progress-bar progress-bar-info\" data-dz-uploadprogress></div></div>\n  <div class=\"dz-success-mark\"><span></span></div>\n  <div class=\"dz-error-mark\"><span></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n</div>",
                maxFiles: 1
            };

            try {

                myDropzone = new Dropzone(".dropzone", options);

            } catch (e) {
                alert('Dropzone.js does not support older browsers!');
            }
        };
        vm.clickCancel = function () {
            if (myDropzone) {
                myDropzone.removeAllFiles(true);
            }

            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };

        //vm.uploadDocument = ko.asyncCommand({
        //    canExecute: function (isExecuting) {
        //        return !isExecuting && vm.isUploadDocument();
        //    },
        //    execute: function (complete) {
        //        vm.isUploadDocument(false);
        //        vm.clearNotifications();

        //        myDropzone.processQueue();
        //        myDropzone.options.autoProcessQueue = true;

        //        complete();
        //    }
        //});

        return vm;

        function getUrl(action) {
            return config.webApiUrl + action;
        }
    }
);
